import { render, staticRenderFns } from "./archive-filter-app.vue?vue&type=template&id=13d9887c&"
import script from "./archive-filter-app.vue?vue&type=script&lang=js&"
export * from "./archive-filter-app.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports